export class Landing {
     
    private id: string; 
    private domain: string; 
    private imagesPath: string; 
    private isWithThumb: boolean; 
    private thumbWidth: number; 
    private thumbHeight: number; 
    private thumbPostfix: string; 
    private bigImageWidth: number; 
    private createdAt: Date; 
    private modifiedAt: Date;

    constructor( id: string, domain: string, imagesPath: string, isWithThumb: boolean, thumbWidth: number, thumbHeight: number, thumbPostfix: string, bigImageWidth: number, createdAt: Date, modifiedAt: Date,) {
        this.id = id;
        this.domain = domain;
        this.imagesPath = imagesPath;
        this.isWithThumb = isWithThumb;
        this.thumbWidth = thumbWidth;
        this.thumbHeight = thumbHeight;
        this.thumbPostfix = thumbPostfix;
        this.bigImageWidth = bigImageWidth;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        
    }

    
    public Id = (): string => {
        return this.id
    }
    public Domain = (): string => {
        return this.domain
    }
    public ImagesPath = (): string => {
        return this.imagesPath
    }
    public IsWithThumb = (): boolean => {
        return this.isWithThumb
    }
    public ThumbWidth = (): number => {
        return this.thumbWidth
    }
    public ThumbHeight = (): number => {
        return this.thumbHeight
    }
    public ThumbPostfix = (): string => {
        return this.thumbPostfix
    }
    public BigImageWidth = (): number => {
        return this.bigImageWidth
    }
    public CreatedAt = (): Date => {
        return this.createdAt
    }
    public ModifiedAt = (): Date => {
        return this.modifiedAt
    }
}